<template>
  <v-container>
    <v-form ref="form">
      <v-layout align-start justify-space-around row fill-height>
        <v-flex xs6>
          <v-text-field v-model="name" :counter="15" :rules="nameRules" label="Nome" required></v-text-field>
        </v-flex>
        <v-flex xs6 ml-3>
          <v-text-field
            v-model="lastName"
            :counter="15"
            :rules="lastRules"
            label="Cognome"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout align-start justify-space-around row fill-height>
        <v-flex xs6>
          <v-text-field v-model="address" :rules="addressRule" label="Indirizzo" required></v-text-field>
        </v-flex>
        <v-flex xs6 ml-3>
          <v-text-field
            v-model="cod"
            :rules="codRule"
            label="Codice Fiscale"
            required
            @blur="codValidate()"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout align-start justify-space-around row fill-height>
        <v-flex xs6>
          <v-text-field v-model="comune" :rules="comuneRule" label="Comune" required></v-text-field>
        </v-flex>
        <v-flex xs6 ml-3>
          <v-text-field v-model="province" :rules="provinceRule" label="Provincia" required></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout align-start justify-space-around row fill-height>
        <v-flex xs12>
          <v-text-field
            id="email"
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
            @blur="validateEmail()"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout align-start justify-space-around row fill-height>
        <v-flex xs12>
          <v-text-field
            v-model="password"
            :rules="pswRules"
            label="Password"
            :append-icon="show1 ? 'visibility' : 'visibility_off'"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            required
            @blur="passwordValidate()"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout align-start justify-space-around row fill-height>
        <v-flex xs12>
          <v-text-field
            v-model="confirmPsw"
            :rules="pswMatchRules"
            label="Conferma Password"
            :append-icon="show2 ? 'visibility' : 'visibility_off'"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout align-start justify-space-around row fill-height>
        <v-flex xs12>
          <v-btn @click="onSignUp()" color="success">Conferma *</v-btn>
          <v-btn color="warning" @click="reset()">Pulisci Campi</v-btn>
          <v-btn color="error" router :to="'/login'">Annulla</v-btn>
        </v-flex>
      </v-layout>
      <v-layout class="mt-3">
        <v-flex>
          <p>* ATTENZIONE: L'invio dei dati di registrazione equivale ad un conferimento del consenso, facoltativo ma necessario,
             per la gestione delle attività connesse. Si allega informativa completa( <a href="https://fitetclimb.iliceimondovi.edu.it/files/Informativa.pdf" target="_blank">informativa</a> )</p>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { FormMixin } from "../mixins/FormMixin";
import { bus } from "../main";
import * as firebase from "firebase";
import { db } from "../main";
export default {
  mixins: [FormMixin],
  data: () => ({
    dialog: false,
    show1: false,
    show2: false,
    valid: true,
    name: "",
    lastName: "",
    address: "",
    comune: "",
    province: "",
    cod: "",
    nameRules: [
      v => !!v || "Nome necessario",
      v => (v && v.length <= 15) || "Il nome deve essere minore di 15 caratteri"
    ],
    addressRule: [
      v => !!v || "Indirizzo necessario",
      v => (v && v.length <= 50) || "L'indirizzo è troppo lungo"
    ],
    lastRules: [
      v => !!v || "Cognome necessario",
      v =>
        (v && v.length <= 15) || "Il cognome deve essere minore di 15 caratteri"
    ],
    comuneRule: [
      v => !!v || "Nome comune necessario",
      v => (v && v.length <= 40) || "Il Nome comune è troppo lungo"
    ],
    provinceRule: [
      v => !!v || "Nome Provincia necessario",
      v => (v && v.length <= 40) || "Il nome della provincia è troppo lungo"
    ],
    codRule: [v => !!v || "Codice fiscale necessario"],
    email: "",
    emailRules: [v => !!v || "Email necessaria"],
    password: "",
    confirmPsw: "",
    pswRules: [v => !!v || "Password necessaria"]
  }),

  computed: {
    //controlla che i campi Password e Conferma Password coincidino
    pswMatchRules() {
      const rules = [];
      if (this.password) {
        const rule = v =>
          (!!v && v) === this.password || "I valori non combaciano";
        rules.push(rule);
      }
      return rules;
    }
  },

  methods: {
    //metodo per la verifica della validità del formato del Codice Fiscale
    codValidate() {
      var valid = /^[A-Z]{6}[A-Z0-9]{2}[A-Z][A-Z0-9]{2}[A-Z][A-Z0-9]{3}[A-Z]$/.test(
        this.cod
      );
      if (valid) {
        this.codRule = [true];
      } else if (this.cod === "" || this.cod === undefined) {
        this.codRule = ["Codice fiscale necessario"];
      } else {
        this.codRule = ["Formato Codice fiscale non corretto"];
      }
    },
    //metodo per la verifica della validità del campo Password
    passwordValidate() {
      var valid = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/.test(
        this.password
      );
      if(valid) {
        this.pswRules = [true]
      }else{
        this.pswRules = ["La password deve essere lunga almeno 6 caratteri, contenere almeno un carattere speciale e un numero ed essere scritta con lettere maiuscole e minuscole"]
      }
    },
    //metodo per la pulizia dei campi del form
    reset() {
      this.$refs.form.reset();
    },

    //metodo per la validazione dell'account da creare + metodo per l'invio dell'email di verifica
    onSignUp() {
      if (this.$refs.form.validate()) {
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(user => {
            this.submit(user);
            var usr = firebase.auth().currentUser;
            usr
              .sendEmailVerification()
              .then(() => {
                bus.$emit("successfullOperation", "Email di verifica inviata");
              })
              .catch(error => {
                bus.$emit(
                  "errorOperation",
                  "Errore: problema nell'invio dell'email di verifica(" +
                    error +
                    ")"
                );
              });
            this.$router.replace("/login");
          })
          .catch(error => {
            bus.$emit(
              "errorOperation",
              "Errore: problema nella creazione dell'utente(" + error + ")"
            );
          });
      }
    },

    //metodo per la creazione su db del nuovo utente
    submit(user) {
      const usr = {
        nome: this.name,
        cognome: this.lastName,
        email: this.email,
        indirizzo: this.address,
        comune: this.comune,
        provincia: this.province,
        codice_fiscale: this.cod,
        ruolo: "Utente",
        autorizzato: "0",
        obsoleto: "0",
        data_obsolescenza: "",
        verificato: "0"
      };
      db.collection("utenti")
        .doc(user.user.uid)
        .set(usr)
        .catch(error => {
          bus.$emit(
            "errorOperation",
            "Errore: problema nel salvataggio dell'utente creato(" + error + ")"
          );
        });
    }
  }
};
</script>
